import axiosServices from '@utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchReports = async (paginationModel, id) => {
  const response = await axiosServices.get(`${backendUrl}/report/study/${id}/`, {
    params: paginationModel,
  });
  return response.data;
};
export const addToReports = async ({ studyId, reportId, formData }) => {
  const response = await axiosServices.put(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/section/`,
    formData,
  );
  return response.data;
};
export const updateReport = async ({ studyId, reportId, sectionId, formData }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/section/${sectionId}/`,
    formData,
  );
  return response.data;
};
export const updateReportTitle = async ({ studyId, reportId, formData }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/`,
    formData,
  );
  return response.data;
};
export const fetchReport = async (studyId, reportId) => {
  const response = await axiosServices.get(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/`,
  );
  return response.data;
};

export const createReport = async (data) => {
  const response = await axiosServices.post(`${backendUrl}/report/`, data);
  return response.data;
};

export const deleteReportSection = async ({ studyId, reportId, sectionId }) => {
  const response = await axiosServices.delete(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/section/${sectionId}/`,
  );
  return response.data;
};
export const deleteReport = async ({ studyId, reportId }) => {
  const response = await axiosServices.delete(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/`,
  );
  return response.data;
};

export const updateReportIndex = async ({ studyId, reportId, formData }) => {
  const response = await axiosServices.patch(
    `${backendUrl}/report/study/${studyId}/report/${reportId}/sectionindex/`,
    formData,
  );
  return response.data;
};
